import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-authenticate-token',
  templateUrl: './authenticate-token.component.html'
})
export class AuthenticateTokenComponent implements OnInit {
  @Input() token: any;
  @Input() email: any;
  @Input() companyId: any;
  @Output() successCallback = new EventEmitter<any>();
  @Output() errorCallback = new EventEmitter<any>();

  @ViewChild('authenticateForm') authenticateForm: NgForm;

  MESSAGECONSTANTS = MESSAGECONSTANTS;
  tokenObject: any;
  loadingFlag: boolean;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.tokenObject = {};
    this.tokenObject.token = this.token;
    this.tokenObject.email = this.email;
    if (this.companyId) {
      this.tokenObject.companyId = this.companyId;
    }
    this.loadingFlag = true;

    setTimeout(() => {
      if (this.email !== undefined) {
        this.authenticateToken();
      }
    }, 500);
  }

  authenticateToken() {
    if (!this.authenticateForm || !this.authenticateForm.invalid) {
      this.authService.authenticateToken(this.tokenObject, (data) => {
        this.successCallback.emit(data);
      }, (error) => {
        this.errorCallback.emit(error);
      });
    }
  }
}
